var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVisa = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 42,
    fill: "none",
    viewBox: "0 0 64 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F7",
    fillRule: "evenodd",
    d: "M0 6c0-3.314 2.686-6 6-6h52c3.314 0 6 2.686 6 6v30c0 3.314-2.686 6-6 6H6c-3.314 0-6-2.686-6-6V6z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4095DB",
    fillRule: "evenodd",
    d: "M0 6c0-3.314 2.686-6 6-6h52c3.314 0 6 2.686 6 6v4H0V6z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4B662",
    fillRule: "evenodd",
    d: "M0 32h64v4c0 3.314-2.686 6-6 6H6c-3.314 0-6-2.686-6-6v-4z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0071CE",
    fillRule: "evenodd",
    d: "M39.229 15.914c-.573-.233-1.473-.488-2.595-.488-2.862 0-4.877 1.576-4.894 3.833-.018 1.669 1.438 2.6 2.536 3.155 1.128.568 1.507.932 1.502 1.44-.007.779-.9 1.135-1.733 1.135-1.159 0-1.775-.176-2.727-.61l-.372-.184-.405 2.6c.675.323 1.927.604 3.226.618 3.042 0 5.019-1.556 5.042-3.966.01-1.324-.761-2.327-2.432-3.156-1.012-.538-1.633-.895-1.626-1.44 0-.482.525-.999 1.659-.999.947-.016 1.633.21 2.167.446l.26.133.392-2.517zM25.83 27.24l1.811-11.612h2.896L28.727 27.24H25.83zm18.407-7.362s-.914 2.578-1.154 3.245h2.404c-.114-.58-.67-3.352-.67-3.352l-.195-1.001c-.078.23-.185.534-.267.766-.074.207-.126.356-.118.342zm2.419-4.238h-2.238c-.694 0-1.214.205-1.518.962l-4.3 10.642h3.042s.496-1.431.608-1.745l1.67.002h.001l2.038.004c.087.405.352 1.74.352 1.74H49L46.657 15.64zm-23.255-.002l-2.834 7.916-.303-1.609v-.001L19.25 16.61c-.175-.736-.684-.954-1.313-.98h-4.669l-.039.24c1.136.302 2.152.735 3.042 1.275l2.575 10.086 3.065-.002 4.56-11.59h-3.069z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVisa, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Visa.68f69d82.svg";
export { ForwardRef as ReactComponent };